<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Group Details</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <button type="submit" class="btn btn-warning btn-fill" @click="editGroup">Edit Group</button>
        </div>
      </div>
      <div class="table-responsive" v-if="group">
        <table class="table table-bordered table-light">
          <tr>
            <th>Id</th>
            <td>{{group.groupDefinitionId}}</td>
          </tr>
          <tr>
            <th>Title</th>
            <td>{{group.groupTitle}}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{group.groupDescription}}</td>
          </tr>
          <tr>
            <th>Group Interests</th>
            <td v-if="group.selectAllInterest !== 1">{{group.csvGroupIntetests}}</td>
            <td v-if="group.selectAllInterest === 1">Select All</td>
          </tr>
          <tr>
            <th>Group Tags</th>
            <td>{{group.csvGroupVideoTagsId}}</td>
          </tr>
          <tr>
            <th>Group Experts</th>
            <td v-if="group.selectAllExpert !== 1">{{group.csvGroupExpertsName}}</td>
            <td v-if="group.selectAllExpert === 1">Select All</td>
          </tr>
          <tr>
            <th>Group Trending Playlists</th>
            <td v-if="group.selectAllTrendPlaylist !== 1">{{group.csvGroupTrendPlaylistTitle}}</td>
            <td v-if="group.selectAllTrendPlaylist === 1">Select All</td>
          </tr>
          <tr>
            <th>Group TONE Articles</th>
            <td v-if="group.selectAllArticle !== 1">{{group.csvGroupArticlesHeading}}</td>
            <td v-if="group.selectAllArticle === 1">Select All</td>
          </tr>
          <tr>
            <th>Header Color</th>
            <td>{{group.headerColor}}</td>
          </tr>
          <tr>
            <th>Footer Color</th>
            <td>{{group.footerColor}}</td>
          </tr>
          <tr>
            <th>Button Color</th>
            <td>{{group.buttonColor}}</td>
          </tr>
          <tr>
            <th>Heading Color</th>
            <td>{{group.headingColor}}</td>
          </tr>
          <tr>
            <th>Min Limit for Work Menu</th>
            <td>{{group.minVidReqdWork}}</td>
          </tr>
          <tr>
            <th>Min Limit for Life Menu</th>
            <td>{{group.minVidReqdLife}}</td>
          </tr>
          <tr>
            <th>Min Limit for Mindbody Menu</th>
            <td>{{group.minVidReqdMindBody}}</td>
          </tr>
          <tr>
            <th>Min Limit for Money Menu</th>
            <td>{{group.minVidReqdMoney}}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td v-if="group.active == '0'">Inactive</td>
            <td v-else>Active</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Viewgroup',
    components: {
      LTable,
    },
    created (){
      this.$store.dispatch('GET_SELECTED_GROUP', this.$route.params.id).then(() =>{
        console.log('selected', this.selectedGroup)
        this.group = this.selectedGroup;
      })
    },
    data () {
      return {
        group: {}
      }
    },
    methods: {
      editGroup(){
        this.$router.push({ name: 'Edit Group', params: { id: this.group.groupDefinitionId}})
      },
    },
    computed: {...mapGetters([
      'selectedGroup'])
    }
  }
</script>

<style>
  th{
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Groups/GroupDetails.vue